import React from 'react';
import SesCollections from '../components/SesCollections';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <SesCollections />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
